import { FC } from "react";
//#region types
import { SalaryDeviationFormTypes } from "models/formTypes";
import { TimeFormViemProps } from "models/propTypes/wintSalaryPropTypes";
import { NumberInputProps, ToggleProps, WintFormConnect } from "models/propTypes/wintFormPropsTypes";
import { TranslationKeys } from "translations";
import { IconDefinitionConstants } from "utils/constants";
//#endregion
//#region components
import { Grid } from "@mui/material";
import {
  VerticalFormField,
  NumberInput,
  Description,
  HorizontalFormField,
  Toggle,
  DateWithDayDisplay,
  AdvancedEditableTable,
} from "components/common/wintForms";
import { DetailsViewItemSkeleton } from "components/common/skeletons";
//#endregion
import { LocalizationHelperInstance } from "utils/helpers";
import cssExports from "theme/styles/main.module.scss";

const ReportTimeForm: FC<TimeFormViemProps> = (props) => {
  const { connect, onFillDaysToggleChanged, values, loading, editMode, isCurrentMonthApproved } = props;

  return (
    <>
      {!editMode && (
        <HorizontalFormField<ToggleProps>
          Component={Toggle}
          {...connect("timeDeviation.fillDayHours")}
          setValue={onFillDaysToggleChanged}
          label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.FillPerDayHours)}
          mainLabelGridSize={8}
          childGridSize={3}
          disabled={loading}
          verticalAlignCenter={true}
        />
      )}
      {values.timeDeviation?.fillDayHours ? (
        loading ? (
          <DetailsViewItemSkeleton />
        ) : (
          <AdvancedEditableTable<SalaryDeviationFormTypes.HoursByDayWithMeta>
            key={values.timeDeviation?.selectedPeriod?.getTime() ?? 0}
            connect={connect as WintFormConnect<any>}
            name={"timeDeviation.dayHours"}
            style={{ marginTop: 16 }}
            value={values.timeDeviation?.dayHours ?? []}
            fields={{
              day: {
                Component: DateWithDayDisplay,
              },
              hours: {
                Component: NumberInput,
                cellWidth: 80,
                extraProps: (row) => ({
                  rightAlign: true,
                  label: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.HoursPascal),
                  suffix: "h",
                  disabled: isCurrentMonthApproved || row.maxTotalMinutes === 0,
                }),
              },
              minutes: {
                Component: NumberInput,
                cellWidth: 80,
                extraProps: (row) => ({
                  rightAlign: true,
                  label: LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.MinutesPascal),
                  suffix: "min",
                  disabled: isCurrentMonthApproved || row.maxTotalMinutes === 0,
                }),
              },
            }}
            idField="id"
            defaultRow={{
              hours: undefined,
              minutes: undefined,
              day: undefined,
              maxTotalMinutes: 480,
            }}
            isCompactTable
            extraCompact
            hideActions
            hideActionsCell
            allowPagination
            hideItemRange
            hideRowsPerPageSelector
            defaultRowsPerPage={10}
          />
        )
      ) : (
        <Grid container direction="column" className={cssExports.formContainer}>
          <Grid item container direction="row" spacing={1}>
            <Grid item xs={6}>
              <VerticalFormField<NumberInputProps>
                Component={NumberInput}
                {...connect("timeDeviation.time.hours")}
                label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.HoursPascal)}
                icon={IconDefinitionConstants.WClock2}
                maxNumber={24}
                maxLength={2}
                disabled={loading || isCurrentMonthApproved}
              />
            </Grid>
            <Grid item xs={6}>
              <VerticalFormField<NumberInputProps>
                Component={NumberInput}
                {...connect("timeDeviation.time.minutes")}
                label={LocalizationHelperInstance.getFormattedMessage(TranslationKeys.Common.MinutesPascal)}
                icon={IconDefinitionConstants.WClock2}
                maxNumber={59}
                maxLength={2}
                disabled={loading || isCurrentMonthApproved}
              />
            </Grid>
          </Grid>
          <Grid item>
            <Description horizontal>
              {LocalizationHelperInstance.getFormattedMessage(TranslationKeys.SalaryDeviation.TimeDescription)}
            </Description>
          </Grid>
        </Grid>
      )}
    </>
  );
};

export default ReportTimeForm;
